import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// import * as pdfMakeModule from "pdfmake/build/pdfmake";
// import * as pdfFontsModule from "pdfmake/build/vfs_fonts";

export const 
generatePDF = async ({
  headerEnglishColumns,
  pdfData,
  width,
  PDFFileName,
}) => {
  pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

//   const pdfMake = pdfMakeModule.default || pdfMakeModule;
//   pdfMake.vfs = pdfFontsModule.default?.pdfMake?.vfs || pdfFontsModule.pdfMake.vfs;

  const documentDefinition = {
    pageSize: "A1",
    pageOrientation: "portrait",
    content: [
      {
        text: "User List Report",
        style: "header",
        margin: [0, 0, 0, 10],
      },
      {
        table: {
          headerRows: 1,
          widths: width,
          body: [
            [
              ...headerEnglishColumns.map((text) => ({
                text: text,
                alignment: "center",
                bold: true,
                fontSize: 12,
              })),
            ],
            ...pdfData.map((row) =>
              row.map((cell) => ({
                text: cell || "",
                fontSize: 10,
                alignment: "center",
              }))
            ),
          ],
        },
      },
    ],
    styles: {
      header: {
        fontSize: 16,
        bold: true,
        alignment: "center",
        color: "black",
      },
    },
  };

  pdfMake.createPdf(documentDefinition).download(`${PDFFileName}.pdf`);
};
